import AuthService from '.'

// está classe estende a classe AuthService mas diferentemente desta,
// não armazena os dados no localStorage para não sobrescrever o da aplicação logada
class AuthServiceTransient extends AuthService {

    constructor(domain) {
        super(domain)

        this.token = null
        this.profile = null
    }

    setProfile(profile) {
        this.profile = profile
    }

    getProfile() {
        return this.profile
    }

    setToken(token) {
        this.token = token
    }

    getToken() {
        return this.token
    }

    logout() {
        this.setToken(null)
        this.setProfile(null)
    }

    get(url, obj) {
        return fetch(this.domain + url, {
            method: 'GET',
            body: obj ? JSON.stringify(obj) : null,
            headers: {
                "Authorization": "Bearer " + this.getToken(),
                "Accept": "application/json",
                "Content-Type": "application/json; charset=utf-8"
            }
        }).then(this._checkStatus).then(response => response.json())
    }

    put(url, obj) {
        return fetch(this.domain + url, {
            method: 'PUT',
            body: JSON.stringify(obj),
            headers: {
                "Authorization": "Bearer " + this.getToken(),
                "Accept": "application/json",
                "Content-Type": "application/json; charset=utf-8",
            },
        }).then(this._checkStatus).then((response) => response.json())
    }

    post(url, obj) {
        return fetch(this.domain + url, {
            method: 'POST',
            body: JSON.stringify(obj),
            headers: {
                "Authorization": "Bearer " + this.getToken(),
                "Accept": "application/json",
                "Content-Type": "application/json; charset=utf-8"
            }
        }).then(this._checkStatus).then(response => response.json())
    }

    delete(url, obj) {
        return fetch(this.domain + url, {
            method: 'DELETE',
            body: obj ? JSON.stringify(obj) : null,
            headers: {
                "Authorization": "Bearer " + this.getToken(),
                "Content-Type": "application/json; charset=utf-8"
            }
        }).then(this._checkStatus)
    }

    postFormData(url, formData) {
        return fetch(this.domain + url, {
            method: 'POST',
            body: formData,
            headers: {
                'Authorization': 'Bearer ' + this.getToken(),
                'Accept': 'application/json'
            }
        }).then(this._checkStatus).then(response => response.json())
    }


}

const authServiceTransient = new AuthServiceTransient()

export default authServiceTransient